import { DailyFootfallPrediction } from './prediction/DailyFootfallPrediction';

/**
 * A class containing week information about footfall predictions and rota.
 */
export class PredictionRotaWeek {
  public static WEEK_FORMAT = 'GGGG-WW';

  id: string;
  from: string;
  to: string;
  dailyPredictions: DailyFootfallPrediction[];
  rotaExist: boolean;

  /**
   * @param id the date formatted in {@link WEEK_FORMAT}.
   * @param from the first day of the week.
   * @param to the last day of the week.
   * @param dailyPredictions all footfall prediction for a week.
   * @param rotaExist indicates if a rota exist for this week.
   */
  constructor(id: string, from: string, to: string, dailyPredictions: DailyFootfallPrediction[], rotaExist: boolean) {
    this.id = id;
    this.from = from;
    this.to = to;
    this.dailyPredictions = dailyPredictions;
    this.rotaExist = rotaExist;
  }
}
